export class SettingsUtils {
  static transformOrderSortBySettings = (sort_by: string): string => {
    switch (sort_by) {
      case 'customer':
        sort_by = 'client';
        break;
      case 'pickup_date':
        sort_by = 'pickupDate';
        break;
      case 'delivery_date':
        sort_by = 'deliveryDate';
        break;
      case 'order_id':
        sort_by = 'loadId';
        break;
      case 'trip_id':
        sort_by = 'tripId';
        break;
      case 'customer_order_number':
        sort_by = 'customerOrderNumber';
        break;
      case 'invoice_status':
        sort_by = 'invoiceStatus';
        break;
      case 'booking_type':
        sort_by = 'bookingMode';
        break;
      case 'pickup_location_name':
        sort_by = 'pickupLocationName';
        break;
      case 'pickup_location_address':
        sort_by = 'pickupAddress';
        break;
      case 'pickup_location_city':
        sort_by = 'pickupCity';
        break;
      case 'pickup_location_state':
        sort_by = 'pickupState';
        break;
      case 'arrival_at_pickup':
        sort_by = 'arrivalAtPickup';
        break;
      case 'delivery_location_name':
        sort_by = 'deliveryLocationName';
        break;
      case 'delivery_location_address':
        sort_by = 'deliveryAddress';
        break;
      case 'delivery_location_city':
        sort_by = 'deliveryCity';
        break;
      case 'delivery_location_state':
        sort_by = 'deliveryState';
        break;
      case 'arrival_at_delivery':
        sort_by = 'arrivalAtDelivery';
        break;
      case 'next_stop_location_name':
        sort_by = 'nextStop';
        break;
      default:
        sort_by = sort_by;
        break;
    }

    return sort_by;
  };

  static transformTripSortBySettings = (sort_by: string): string => {
    switch (sort_by) {
      case 'customer':
        sort_by = 'client';
        break;
      case 'pickup_date':
        sort_by = 'pickupDate';
        break;
      case 'delivery_date':
        sort_by = 'deliveryDate';
        break;
      case 'order_id':
        sort_by = 'loadId';
        break;
      case 'customer_order_number':
        sort_by = 'customerOrderNumber';
        break;
      case 'trip_id':
        sort_by = 'tripId';
        break;
      case 'settlement_status':
        sort_by = 'settlementStatus';
        break;
      case 'pickup_location_name':
        sort_by = 'pickupLocationName';
        break;
      case 'pickup_location_address':
        sort_by = 'pickupAddress';
        break;
      case 'pickup_location_city':
        sort_by = 'pickupCity';
        break;
      case 'pickup_location_state':
        sort_by = 'pickupState';
        break;
      case 'delivery_location_name':
        sort_by = 'deliveryLocationName';
        break;
      case 'delivery_location_address':
        sort_by = 'deliveryAddress';
        break;
      case 'delivery_location_city':
        sort_by = 'deliveryCity';
        break;
      case 'delivery_location_state':
        sort_by = 'deliveryState';
        break;
      case 'arrival_at_pickup':
        sort_by = 'arrivalAtPickup';
        break;
      case 'arrival_at_delivery':
        sort_by = 'arrivalAtDelivery';
        break;
      case 'next_stop_location_name':
        sort_by = 'nextStop';
        break;
      case 'dispatch_acceptance':
        sort_by = 'dispatchAcceptance';
        break;
      case 'dimension':
        sort_by = 'dimension';
        break;
      case 'unit':
        sort_by = 'unit';
        break;
      default:
        sort_by = sort_by;
    }

    return sort_by;
  };

  static transformTripFrontendToBackendSort = (field: string): string => {
    switch (field) {
      case 'client':
        return 'customer';
      case 'pickupDate':
        return 'pickup_date';
      case 'deliveryDate':
        return 'delivery_date';
      case 'loadId':
        return 'order_id';
      case 'customerOrderNumber':
        return 'customer_order_number';
      case 'tripId':
        return 'trip_id';
      case 'settlementStatus':
        return 'settlement_status';
      case 'pickupLocationName':
        return 'pickup_location_name';
      case 'pickupAddress':
        return 'pickup_location_address';
      case 'pickupCity':
        return 'pickup_location_city';
      case 'pickupState':
        return 'pickup_location_state';
      case 'deliveryLocationName':
        return 'delivery_location_name';
      case 'deliveryAddress':
        return 'delivery_location_address';
      case 'deliveryCity':
        return 'delivery_location_city';
      case 'deliveryState':
        return 'delivery_location_state';
      case 'arrivalAtPickup':
        return 'arrival_at_pickup';
      case 'arrivalAtDelivery':
        return 'arrival_at_delivery';
      case 'nextStop':
        return 'next_stop_location_name';
      case 'dispatchAcceptance':
        return 'dispatch_acceptance';
      case 'dimension':
        return 'dimension';
      case 'unit':
        return 'unit';
      default:
        return field;
    }
  };

  static transformOrderFrontendToBackendSort = (field: string): string => {
    switch (field) {
      case 'client':
        return 'customer';
      case 'pickupDate':
        return 'pickup_date';
      case 'deliveryDate':
        return 'delivery_date';
      case 'loadId':
        return 'order_id';
      case 'tripId':
        return 'trip_id';
      case 'customerOrderNumber':
        return 'customer_order_number';
      case 'invoiceStatus':
        return 'invoice_status';
      case 'bookingMode':
        return 'booking_type';
      case 'pickupLocationName':
        return 'pickup_location_name';
      case 'pickupAddress':
        return 'pickup_location_address';
      case 'pickupCity':
        return 'pickup_location_city';
      case 'pickupState':
        return 'pickup_location_state';
      case 'arrivalAtPickup':
        return 'arrival_at_pickup';
      case 'deliveryLocationName':
        return 'delivery_location_name';
      case 'deliveryAddress':
        return 'delivery_location_address';
      case 'deliveryCity':
        return 'delivery_location_city';
      case 'deliveryState':
        return 'delivery_location_state';
      case 'arrivalAtDelivery':
        return 'arrival_at_delivery';
      case 'nextStop':
        return 'next_stop_location_name';
      default:
        return field;
    }
  };

  static getTripColumnSortableStatus = (columnName: string): boolean => {
    // Columns that aren't sortable now but can be removed when BE is updated
    const nonSortableColumns = [
      'manifestType',    // Border crossing manifest
      'commodity',       // Commodity
      'onTimeStatus',    // On-time status
      'quantity',        // Quantity
      'dimension',       // Dimension
      'unit'            // Unit
    ];

    return !nonSortableColumns.includes(columnName);
  };

  static transformCarrierSortBySettings = (sort_by: string): string => {
    switch (sort_by) {
      case 'name':
        sort_by = 'name';
        break;
      case 'email':
        sort_by = 'email_address';
        break;
      case 'phone':
        sort_by = 'phone';
        break;
      case 'mc_number':
        sort_by = 'mc_number';
        break;
      case 'tax_id':
        sort_by = 'tax_id';
        break;
      default:
        sort_by = sort_by;
    }

    return sort_by;
  };
}
